import CategoryInformation from 'adminDashboard/common/categoryInformation'
import { formatMoney } from 'common'
import { TFunction } from 'i18next'

//
import { NamedItem } from 'core'

//
import { Button, Card, Col, Collapse, CollapseItem, Icon, Row, Tooltip } from 'common/components'
import { now, parseZone } from 'common/dateFormatters'

//
import './styles.less'

const DEFAULT_ACTIVE_KEY = 1

type CardPerksAllowanceProps = {
  translate: TFunction<'translation', undefined, 'translation'>
  icon: string
  title: string
  availableAllowanceTitle: string
  availableAllowanceValue: number
  buttonText: string
  onButtonClick: () => void
  monthlyAllowanceValue: number
  type: string
  eligibleCategories: NamedItem[]
  eligibleCategoriesTitle?: string
  isEligible: boolean
  offerSameAllowance: boolean
  startDate: Date
  endDate: Date
  hasEndPerkRunOutDaysEnded: boolean
  benefitEndDate: string
  daysToRunOut: number
  runOutDays: number
  isPerkContinuous: boolean
}

const CardPerksAllowance: React.FC<CardPerksAllowanceProps> = (props) => {
  return (
    <>
      <Card className="card_perks_allowance mr-8 ml-8">
        <div className="mb-24">
          <Row gutter={4} className="card_perks_allowance-row">
            <Col>
              <Icon type={`${props.icon}`} className="color-green-6 icon-style" />
            </Col>
            <Col>
              <Tooltip title={props.title} position="topLeft">
                <div className="ellipsis semi-bold color-gray-9 font-20">{props.title}</div>
              </Tooltip>
            </Col>
          </Row>
        </div>
        {props.isEligible && !props.offerSameAllowance && (
          <div className="mb-24">
            <h6 className="mb-16">
              <span className="color-gray-7 font-14">{props.availableAllowanceTitle}</span>
            </h6>
            <div className="color-grey-9 semi-bold font-24">{formatMoney(props.availableAllowanceValue, true)}</div>
          </div>
        )}
        {!props.offerSameAllowance && (
          <div className="mb-24">
            <CategoryInformation
              isContinuous={props.isPerkContinuous}
              runOutDays={props.runOutDays}
              daysToRunOut={props.daysToRunOut}
              monthlyAllowanceValue={props.monthlyAllowanceValue}
              type={props.type}
              startDate={props.startDate}
              endDate={props.endDate}
              benefitEndDate={props.benefitEndDate}
            />
          </div>
        )}

        <div className="mb-24">
          <Tooltip title={!props.isEligible ? 'Your benefit has not started yet' : ''}>
            <Button
              disabled={!props.isEligible || props.hasEndPerkRunOutDaysEnded || parseZone(props.startDate) > now()}
              className="c-white button_style"
              type="primary"
              onClick={props.onButtonClick}
            >
              {props.buttonText}
            </Button>
          </Tooltip>
        </div>

        <Collapse>
          <CollapseItem
            header={
              <h5 className="semi-bold mb-0">
                {props.translate('ee-dashboard.home.perks-allowances.perk-cards.title') +
                  ' (' +
                  props.eligibleCategories.length +
                  ')'}
              </h5>
            }
            content={
              <>
                {' '}
                <div className="mb-8">
                  <p className="color-gray-8 semi-bold">{props.eligibleCategoriesTitle}</p>
                </div>
                {props.eligibleCategories.map((ec) => (
                  <>
                    <div>
                      <h6 key={ec.id} className="color-gray-9 mb-8">
                        <Icon type="far fa-check" className="color-green-6 pr-16" />
                        {ec.name}
                      </h6>
                    </div>
                  </>
                ))}
              </>
            }
            key={DEFAULT_ACTIVE_KEY}
          ></CollapseItem>
        </Collapse>
      </Card>
    </>
  )
}

export default CardPerksAllowance
